import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	AllCitiesData,
	CityData,
	CountryData,
	StateData,
} from '@/interfaces/countries';

class CountriesService {
	constructor(private client: AxiosInstance) {}

	async getCountries(): Promise<HttpResponse<CountryData>> {
		return this.client.get('/countries');
	}
	async getStates(countryId: string): Promise<HttpResponse<StateData>> {
		return this.client.get(`/countries/states?country_id=${countryId}`);
	}
	async getCities(
		stateId: string,
		page?: number,
		search?: string,
		limit?: number
	): Promise<HttpResponse<CityData>> {
		const auxParams = [];
		limit && auxParams.push(`limit=${limit}`);
		page && auxParams.push(`page=${page}`);
		search && auxParams.push(`search=${search}`);
		const params = auxParams.join('&');
		return this.client.get(
			params.length > 0
				? `/countries/cities?state_id=${stateId}&${params}`
				: `/countries/cities?state_id=${stateId}`
		);
	}
	async getCityById(
		cityId: string
	): Promise<HttpResponse<{ city: { id: number; name: string } }>> {
		return this.client.get(`/countries/cities/${cityId}`);
	}
	async getAllCities(
		page: number,
		limit: number,
		search?: string
	): Promise<HttpResponse<AllCitiesData>> {
		let url = `/countries/all-cities?page=${page}&limit=${limit}`;
		if (search) {
			url += `&search=${search}`;
		}
		return this.client.get(url);
	}

	async createCity(data: any) {
		return this.client.post('/countries/cities', data);
	}

	async updateCity(id: number, data: any) {
		return this.client.put(`/countries/cities/${id}`, data);
	}

	async deleteCity(id: number) {
		return this.client.delete(`/countries/cities/${id}`);
	}
}

export const countriesService = new CountriesService(axiosClient);
